import connectedComponent from './ToggleElementButton';

export default connectedComponent;